import { Component, inject } from '@angular/core';
import { MailService } from '~shared/services/mail/mail.service';
import { ModulesService } from '~shared/services/modules/modules.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  mailService = inject(MailService);
  modulesService = inject(ModulesService);

  closeMailPopin(id: number) {
    this.mailService.removeEmailWindow(id);
  }

  closeAllEmailWindowsExcept(id: number) {
    this.mailService.closeAllEmailWindowsExcept(id);
  }
}
